import { Divider, Stack } from "@mui/material";
import Block from "@/components/Block";
import BookingSearchDetails from "./BookingSearchDetails";
import CampgroundHeader from "./CampgroundHeader";

export default function TabletSummaryCard() {
  return (
    <Block sx={{ position: "relative" }}>
      {/* Positioned absolutely (rather than via Stack's `divider` prop) so
          it can bleed edge to edge of the card through Block's padding —
          Stack's `spacing` prop forces margin:0 on direct children, which
          would silently override a margin-based bleed here too. */}
      <Divider
        orientation="vertical"
        sx={{ position: "absolute", top: 0, bottom: 0, left: "50%", transform: "translateX(-50%)" }}
      />
      <Stack direction="row" spacing={3}>
        <Stack sx={{ flex: 1, minWidth: 0 }} justifyContent="center">
          <CampgroundHeader variant="expanded" />
        </Stack>
        <Stack sx={{ flex: 1, minWidth: 0 }} justifyContent="center">
          <BookingSearchDetails variant="compact" />
        </Stack>
      </Stack>
    </Block>
  );
}
